export default __webpack_public_path__ + "static/media/Haldiram.441dbe1e.jpeg";